import { SelectEvent } from '@progress/kendo-angular-upload';
export class AssetPhotoUploadModel {
  selectEvent: SelectEvent;
  assetId: number;
}
